export default __webpack_public_path__ + "static/media/2.5c7d6c5d.png";